import React, { Component } from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { getCache, setCache } from "./collection3Cache";

import { Product5 } from "../../../services/script";
import { addToCart, addToWishlist } from "../../../actions";
import ProductItem from "./product-item";
import ProductItemSkeleton from "./product-item-skeleton";
import {
  auth,
  addCartItemTofirestore,
  addWishlistTofirestore,
} from "../../../firebase/firebase.utils";
import "./collection2.css";

import "../../collection/common/product-list-item.css";
import { withRouter } from "react-router-dom";
import { toast } from "react-toastify";
import Axios from "axios";
class CollectionThree extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
    };
  }

  componentDidMount = async () => {
    console.log("componentDidMount called");

    const keyword = this.props.categoryId;
    const framePosition = 1;
    const filterByCategory = "Default";

    // Generate unique cache key for this fetch
    const cacheKey = `products-${keyword}-${framePosition}-${filterByCategory}`;

    // 1️⃣ Check in-memory cache first
    const cached = getCache(cacheKey);
    if (cached) {
      console.log("Loaded from memory cache", cached);
      this.setState({ items: cached });
      return; // Do NOT hit the API
    }

    console.log("Fetching from API...");

    // 2️⃣ API call
    let response;
    try {
      // for development, use full URL to avoid CORS issues. In production, use relative URL. 
      let link = `https://alg.com.bd/api/products/search`
      if (process.env.NODE_ENV === "production") {
        link = `/api/products/search`;
      }
      response = await Axios.get(link, {
        params: {
          keyword,
          framePosition,
          filterByCategory,
        },
      });
    } catch (error) {
      console.error("API error:", error);
      return;
    }

    const data = response.data;

    if (data && data.products && data.products.length > 0) {
      this.setState({
        items: data.products,
      });

      // 3️⃣ Store in memory cache with TTL (e.g., 5 minutes)
      setCache(cacheKey, data.products, 5 * 60 * 1000); // 5 mins
    } else {
      this.setState({
        items: [],
      });
    }
  };

  addToReduxAndFirestoreCart = (product, qty) => {
    const { addToCart } = this.props;
    auth.onAuthStateChanged(
      async (userAuth) => await addCartItemTofirestore(userAuth, product, qty)
    );
    addToCart(product, qty);
  };

  addToReduxAndFirestoreWishlist = async (product) => {
    const { addToWishlist, currentUser } = this.props;
    console.log(this.props);
    if (currentUser && currentUser.uid) {
      await addWishlistTofirestore(currentUser, product);
      toast.success("Item addded to wishilist");
    } else {
      alert("You must login first.");
    }
  };

  render() {
    const { items, topCollectionItems, symbol, title, subtitle } = this.props;
    // console.log(this.props)
    let renderableItems = this.state.items;

    return (
      <div className="each-home-category-container">
        {/*Paragraph*/}

        <section
          className="section-b-space j-box pets-box ratio_square  products-container-section"
          style={{ marginTop: 0 }}
        >
          <div className="container">
            <div className="row">
              <div className="col" style={{ paddingLeft: 0, paddingRight: 0 }}>
                <div className="title1 title5">
                  {subtitle ? (
                    <h4
                      style={{
                        cursor: "pointer",
                        color: "#ff4a4e",
                        fontWeight: "bold",
                      }}
                    >
                      {subtitle}
                    </h4>
                  ) : (
                    ""
                  )}
                  <h2 className="title-inner1" style={{ cursor: "pointer" }}>
                    {title}
                  </h2>
                  <hr role="tournament6" className="tournament-line" />
                </div>
                <Slider {...Product5} className="product-5 product-m no-arrow">
                  {renderableItems && renderableItems.length > 0
                    ? renderableItems.slice(0, 6).map((product, index) => (
                        <div key={index}>
                          <ProductItem
                            product={product}
                            symbol={symbol}
                            onAddToWishlistClicked={() =>
                              this.addToReduxAndFirestoreWishlist(product)
                            }
                            onAddToCartClicked={() =>
                              this.addToReduxAndFirestoreCart(product, 1)
                            }
                            key={index}
                          />
                        </div>
                      ))
                    : [1, 2, 3, 4, 5, 6].map((product, index) => (
                        <div key={index}>
                          <ProductItemSkeleton key={index} />
                        </div>
                      ))}
                </Slider>
                <Slider {...Product5} className="product-5 product-m no-arrow">
                  {renderableItems &&
                    renderableItems.length > 0 &&
                    renderableItems.slice(6, 12).map((product, index) => (
                      <div key={index}>
                        <ProductItem
                          product={product}
                          symbol={symbol}
                          onAddToWishlistClicked={() =>
                            this.addToReduxAndFirestoreWishlist(product)
                          }
                          onAddToCartClicked={() =>
                            this.addToReduxAndFirestoreCart(product, 1)
                          }
                          key={index}
                        />
                      </div>
                    ))}
                </Slider>
                <Slider {...Product5} className="product-5 product-m no-arrow">
                  {renderableItems &&
                    renderableItems.length > 0 &&
                    renderableItems.slice(12, 20).map((product, index) => (
                      <div key={index}>
                        <ProductItem
                          product={product}
                          symbol={symbol}
                          onAddToWishlistClicked={() =>
                            this.addToReduxAndFirestoreWishlist(product)
                          }
                          onAddToCartClicked={() =>
                            this.addToReduxAndFirestoreCart(product, 1)
                          }
                          key={index}
                        />
                      </div>
                    ))}
                </Slider>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "flex-end",
                    color: "#f48110",
                    marginRight: 12,
                    cursor: "pointer",
                  }}
                  onClick={() =>
                    this.props.history.push(
                      `/collection/${this.props.categoryId}`
                    )
                  }
                >
                  <span style={{ color: "#f48110" }}>View all ►►</span>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  items: state.data.products,
  topCollectionItems: state.data.products
    .filter((item) => item.availability == ownProps.status)
    .slice(12, 30),
  symbol: state.data.symbol,
  cartItems: state.cartList,
  currentUser: state.user.currentUser,
});

export default withRouter(
  connect(mapStateToProps, { addToWishlist, addToCart })(CollectionThree)
);
